import store from '@/store/index.js'

/*
  See @/components/registry to find registered components

  ## Events:
  * $emit('close') -> will close the dialog
  * $emit('saved', data) -> will emit a globa update via vuex**


** To listen to a global vuex event, create a computed value and watch it.

e.g.:

```
computed: {
  newlocationEvent () {
    return this.$store.getters.getEventById('new-location-wizard')
  },
  newlocationEventTouch () {
    return this.newLocationEvent.touch
  },
  newlocationEventData () {
    return this.newLocationEvent.data
  }
},
watch: {
  newlocationEventTouch () {
    this.refresh()
  }
}

```
*/

export default {
  methods: {
    launchSpacePicker() { },
    launchInviteWizard(spaceId) {
      let options = {
        id: 'invite-member-wizard',
        title: 'Invite a new member to your team',
        visible: true,
        componentAttrs: {
          spaceId,
          touch: Math.random(),
        },
        attrs: { width: 600 }
      }
      store.commit('setActiveDialog', options)
    },
    launchNewSpaceWizard() {
      // this.$router.push({path: '/wizards/space'})
      let options = {
        id: 'new-space-wizard',
        title: 'Create a new space or location',
        visible: true,
        componentAttrs: {
          touch: Math.random(),
        },
        attrs: { width: 600 }
        // attrs: { fullscreen: true }
      }
      store.commit('setActiveDialog', options)
    },
    launchNewLocationWizard(spaceId) {
      let options = {
        id: 'new-location-wizard',
        title: 'Add a location',
        visible: true,
        componentAttrs: {
          spaceId,
          touch: Math.random(),
        },
        attrs: { fullscreen: false }
      }
      store.commit('setActiveDialog', options)
    },
    launchLocationForm(spaceId, locationId) {
      let options = {
        id: 'location-form',
        title: 'Location',
        visible: true,
        componentAttrs: { spaceId, locationId, withTitle: false },
        attrs: { fullscreen: true }
      }
      store.commit('setActiveDialog', options)
    },
    launchOperatingHoursForm(operationHours) {
      let options = {
        id: 'operation-hours-form',
        title: 'Oerating Hours',
        visible: true,
        componentAttrs: {
          value: operationHours,
          withFab: true
        },
        attrs: { fullscreen: false, width: '460px' }
      }
      store.commit('setActiveDialog', options)
    },
    launchRuleForm() { },
    launchQuickCreateAppointmentType(spaceId, practitioner) {
      let componentAttrs = { spaceId }
      if (practitioner) {
        componentAttrs.practitioner = practitioner
        componentAttrs.practitionerId = practitioner.id
      }
      componentAttrs.touch = Math.random()
      let options = {
        id: 'quick-appointment-type-form',
        title: 'Add an appointment type',
        visible: true,
        componentAttrs,
        attrs: { fullscreen: true }
      }
      store.commit('setActiveDialog', options)
    },
    launchAppointmentTypeForm(spaceId, productId, spaceName) {
      if (!spaceName) { spaceName = 'Appointment type' }
      let options = {
        id: 'appointment-type-form',
        title: spaceName,
        visible: true,
        componentAttrs: { spaceId, productId },
        attrs: { fullscreen: true }
      }
      store.commit('setActiveDialog', options)
    }
  }
}
